import type { ScreenSchema } from './types';

/**
 * Schema for the `split`, `split-2-1`, and `split-1-2` templates.
 *
 * All three are rendered by screen-split.vue, which orchestrates audio across
 * the parent screen and its left/right child panels. `managesOwnSectionAudio`
 * prevents uc-screen's generic sectionActive watcher from firing separately.
 *
 * Audio behaviour (managed by screen-split.vue):
 *   1. Parent intro — reads heading/text/instructions from the parent screen's
 *      own uc-content block (same fields as the generic content schema intro).
 *   2. Left child intro — queued after the parent intro; resolves via
 *      useChildScreenAudio().resolveChildIntro() using the child's own schema.
 *   3. Right child intro — queued after the left child; same resolution.
 *
 * Unlike sticky, there are no per-child ScrollTriggers — both panels are
 * simultaneously visible, so the sequence plays on section activation only.
 *
 * S3 audio key convention:
 *   - Parent intro   → screen.id  (standard intro marker)
 *   - Left child-0   → child.id if present; `${parentId}_left_0` if absent
 *   - Right child-0  → child.id if present; `${parentId}_right_0` if absent
 *
 * The synthesised `${parentId}_${side}_${index}` id mirrors the sticky convention
 * and is stable across renders so it can serve as a JiT cache key.
 */
const splitSchema: ScreenSchema = {
  template: ['split', 'split-2-1', 'split-1-2'],
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};

export default splitSchema;
